import { render } from "./ButtonWithIcon.vue?vue&type=template&id=03b13763&scoped=true"
import script from "./ButtonWithIcon.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ButtonWithIcon.vue?vue&type=script&charset=utf-8&lang=js"

import "./ButtonWithIcon.vue?vue&type=style&index=0&id=03b13763&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b13763"]])

export default __exports__